// Dynamically replaces variables after a translation happens
import { Jed } from 'jed'
import { underscoredCurrentLocale } from './current_locale'

declare global {
  interface Window {
    locales: object
  }
}

const availableLocales = window.locales || {}
// Error: Can not retrieve __ property from null
type JEDType = {
  gettext: (phrase: string) => string
  ngettext: (phrase: string, pluralPhrase: string, num: number) => string
}

function generateFallbackJedClass(): JEDType {
  return {
    gettext(phrase: string): string {
      return phrase
    },
    ngettext(singularPhrase: string, pluralPhrase: string, num: number): string {
      return num == 1 ? singularPhrase : pluralPhrase
    },
  }
}

const jed: JEDType = availableLocales[underscoredCurrentLocale]
  ? new Jed(availableLocales[underscoredCurrentLocale])
  : generateFallbackJedClass()

const translate = (phrase: string, args?: object): string => {
  if (!phrase) {
    return ''
  }
  const translatedPhrase = jed.gettext(phrase)
  if (args) {
    const sprintfFriendlyPhrase = translatedPhrase.replace(/%{(.+?)}/g, '%($1)s')
    return Jed.sprintf(sprintfFriendlyPhrase, args)
  } else {
    return translatedPhrase
  }
}

const ntranslate = (singularPhrase: string, pluralPhrase: string, num: number, args: object): string => {
  const translatedPhrase = jed.ngettext(singularPhrase, pluralPhrase, num)
  if (args) {
    const sprintfFriendlyPhrase = translatedPhrase.replace(/%{(.+?)}/g, '%($1)s')
    return Jed.sprintf(sprintfFriendlyPhrase, args)
  } else {
    return translatedPhrase
  }
}

export { translate, translate as __, ntranslate, ntranslate as n__ }
